import React from "react";
import { Container, Grid } from "@mui/material";
import ReactPlayer from 'react-player/lazy';

import Heading from "../../components/Heading/heading";
import p2eimg from '../../image/shibapuppromo.mp4';

const PlayToEarn = () => {
    return(
        <div id="play-to-earn" className="SE---playToEarn py-5 my-5">
            <Container maxWidth="lg">
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid
                        xs={12}
                        className="text-center"
                    >
                        <Heading
                            subtitle="Game"
                            title="Play to Earn"
                        />
                    </Grid>
                    <Grid
                        xs={12}
                        className="text-center my-4"
                    >
                        {/* <img src={p2eimg} classname="img-fluid w-100" style={{maxWidth:600, width:'100%'}} /> */}
                        <ReactPlayer
                            className='react-player'
                            url={p2eimg}
                            width='100%'
                            height='100%'
                            playing
                            muted
                            loop
                        />
                    </Grid>
                    <Grid
                        xs={12}
                        className="text-center"
                    >
                        <p className="text-light mx-auto" style={{maxWidth:430}}>This is something you don't want to miss out on. Have you ever thought of putting your gaming addiction to good use?<br />Now you can! Play a simple game and earn tokens, put all of your talents to use.</p>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default PlayToEarn;